import { BrandsLogos } from "./BrandsLogos";

type Props = {
  brand?: string;
};

export const Header = ({ brand }: Props) => {
  brand = brand?.toUpperCase();

  let color = "white";
  if (brand === "KTM") {
    color = "#ec671b";
  } else if (brand === "HUSQVARNA") {
    color = "#1c2a4b";
  } else if (brand === "GASGAS") {
    color = "#cc0e25";
  } else if (brand === "WP") {
    color = "#e3000f";
  }

  return (
    <div className="flex w-full flex-wrap justify-between items-center pt-2 pb-2 ps-2" style={{ backgroundColor: color }}>
      <h1 className="grow-[1] text-xl sm:text-3xl ms-1" style={{ color: brand ? "white" : "black" }}>
        Parts Finder {brand ? brand.toUpperCase() : null}
      </h1>
      <BrandsLogos brand={brand?.toUpperCase()} />
    </div>
  );
};
